import { render, staticRenderFns } from "./CooperationPlusIcon.vue?vue&type=template&id=aa5dd81a&scoped=true&"
import script from "./CooperationPlusIcon.vue?vue&type=script&lang=js&"
export * from "./CooperationPlusIcon.vue?vue&type=script&lang=js&"
import style0 from "./CooperationPlusIcon.vue?vue&type=style&index=0&id=aa5dd81a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5dd81a",
  null
  
)

export default component.exports